export default (client) => ({
  get(id) {
    return client.request({
      method: 'get',
      url: `/wooOrders/${id}`,
    });
  },
  find(filterParams) {
    return client.request({
      method: 'get',
      url: '/wooOrders',
      params: { ...filterParams },
    });
  },
  create(payload) {
    return client.request({
      method: 'post',
      url: '/wooOrders',
      data: payload,
    });
  },
  patch(id, payload) {
    return client.request({
      method: 'put',
      url: `/wooOrders/${id}`,
      data: payload,
    });
  },
});
